import { useEffect, useState } from 'react';
import { ApiError } from '@/shared/api';
import { getStorageProfile } from '@/shared/storage-api';

/**
 * NEX-1164 — the shell's one "does this login have a depósito account?" check. Firebase keeps the
 * session, so a login that signed in with Google, reached `/registro` and closed the tab comes back
 * straight into the shell without passing through `Login.tsx`'s own check; this sends it back to
 * the registration form instead of leaving it on Solicitudes' error.
 *
 * `true` only on `GET /storage/me` → 404 `STORAGE_PROFILE_NOT_FOUND` (same match as
 * `src/pages/empresa/storage-api.ts`'s `isStorageProfileMissing`). Any other failure is not proof
 * the account is missing — the pages show their own error, same reasoning as `Login.tsx`.
 *
 * Deliberately non-blocking: the shell renders meanwhile, so an account that exists (every login
 * but this one edge case) pays no extra wait. Uses `@/shared/storage-api`'s own `getStorageProfile`
 * (not Mi empresa's) per root `AGENTS.md`'s coupling contract.
 */
export function useStorageProfileGate(enabled: boolean): boolean {
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    getStorageProfile().catch((err: unknown) => {
      if (!cancelled && err instanceof ApiError && err.status === 404 && err.code === 'STORAGE_PROFILE_NOT_FOUND') {
        setMissing(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return missing;
}
